<template>
  <div class="crowdDetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <swiper :options="swiperOption">
      <swiper-slide class="swiper-slide games">
        <a href=""><img :src="baseUrl+setDetail.images"></a>
      </swiper-slide>
    </swiper>
    <div class="cont">
      <div class="info">
        <h2 class="title"><div>{{setDetail.title}}</div>
          <span>￥{{setDetail.rate}}元/只</span>
          <span class="curt">库存:{{setDetail.stock - setDetail.payTotal}}只</span>
        </h2>
        <h2 style="padding-bottom:10px">
          <p>周一至周日</p>
          <p>投放地址：{{setDetail.address}}</p>
          <p>预定形式发货，您购买的走地鸡平台将会以最快能出栏的鸡进行发货</p>
          <p>{{setDetail.content}}</p>
        </h2>
        <div class="goDetail" @click="getList">详情<i class="el-icon-arrow-right"></i></div>
      </div>
      
      <div class="trends">
        <h2>每日动态</h2>
        <dl>
          <dd v-for="(item,i) in setTrends">
            <img class="avatar" :src="item.avatar">
            <div class="plnr">
              <div class="h2">
                <span>{{item.username}}</span>
                <font>{{item.create_time}}</font>
              </div>
              <p>{{item.content}}</p>
              <videoPlayer v-if="item.files != ''" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></videoPlayer>
            </div>
          </dd>
        </dl>
      </div>
      <div class="trends">
        <h2>用户点评</h2>
        <dl>
          <dd v-for="(item,i) in setComment">
            <img class="avatar" :src="item.avatar">
            <div class="plnr">
              <div class="h2">
                <span>{{item.username}}</span>
                <font>{{item.create_time}}</font>
              </div>
              <p>{{item.content}}</p>
              <div class="images">
                <img v-for="(vo,k) in item.image" :src="baseUrl+vo">
              </div>
            </div>
          </dd>
        </dl>
      </div>
    </div>
    <div style="height:55px"></div>
    <div class="footer1">
      <div class="foot-title">
        <span>合计：<i>￥</i><b>{{setDetail.rate}}</b>
        </span>
        <span>每只鸡</span>
      </div>
      <div v-if="setDetail.stock - setDetail.payTotal > 0" class="pay" @click="toPush(setDetail.id,'cpayment')">
        <span>立即购买</span>        
      </div>
      <div v-else class="pay">
        <span style="background:#bbb">售罄</span>        
      </div>
    </div>


    <el-drawer :visible.sync="drawer" size="80%" :direction="direction" :withHeader="false" :show-close="false">
      <div style="height:0px"></div>
      <ul :style="'height:'+curHeight+'px;'" class="chickenList">
          <li v-for="(item,key) in setList" @click="url(item.equip_id)">
            <div class="title">{{item.sex}}{{item.breed}}<font>{{item.birth_time}}</font></div>

            <div class="local">
              <span class="address">{{item.address}}</span>
            </div>
          </li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import { videoPlayer } from 'vue-video-player'
  import '../../assets/video.js/dist/video-js.css'
  export default {
    data() {
      return {
        swiperOption: {
          autoplay : {
            disableOnInteraction: false, //用户操作后是否禁止自动循环
            delay: 1000 //自自动循环时间
          }, //可选选项，自动滑动
          initialSlide: 0,
          speed: 1000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
          loop:false, //循环切换
          grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
          autoHeight: true,   //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true, //设置为true时，能使用鼠标滚轮控制slide滑动
          observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
       
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },

        playerOptions: {
           playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
           autoplay: false, // 如果为true,浏览器准备好时开始回放。
           muted: false, // 默认情况下将会消除任何音频。
           loop: false, // 是否视频一结束就重新开始。
           preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
           language: 'zh-CN',
           aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
           fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
           sources: [{
            type: "video/mp4", // 类型
            src: '' // url地址
           }],
           poster: '', // 封面地址
           notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
           controlBar: {
              timeDivider: true, // 当前时间和持续时间的分隔符
              durationDisplay: false, // 显示持续时间
              remainingTimeDisplay: true, // 是否显示剩余时间功能
              fullscreenToggle: true // 是否显示全屏按钮
           }
        },
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        setDetail:[],
        code:'',
        drawer:false,
        direction: 'rtl',
        setList:[],
        setTrends:[],
        setComment:[]
      };
    },
    created(){
    },
    components: {
      videoPlayer
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          //var url = encodeURIComponent('http://user.4008005216.com/main/cdetail?id='+id);
          //window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.getTrends();
      this.getComment()
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      url:function(id){
        location.href='https://farm.aiotagro.com/source/index.html?device_sn='+id+'&cate=1&t=1695616284'
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/chicken/detail',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.setDetail = res.data;
          that.getQquey();
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      getList:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/chicken/chickenList',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.setList = res.data;
          that.drawer = true;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },


      getTrends:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/chicken/trends',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.setTrends = res.data;
          var arr = [];
          for(var i=0;i<res.data.length;i++){
            arr.push({type: "video/mp4",src: that.$host+res.data[i].files})
          }
          that.playerOptions.sources = arr;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      getComment:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/chicken/comment',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.setComment = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      getQquey:function(){
        var that = this;
        var id = that.$route.query.id;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'onMenuShareAppMessage',
              'onMenuShareTimeline'
            ]
          });
          wx.ready(function() {
            //分享到朋友圈
            wx.onMenuShareTimeline({
                title:that.setDetail.title, // 分享标题
                link:'http://user.4008005216.com/main/cdetail?id='+id, 
                imgUrl:that.baseUrl+that.setDetail.images, // 分享图标
                success: function () {
                },
            });
            //分享给朋友
            wx.onMenuShareAppMessage({
                title:that.setDetail.title,
                desc:'地址：'+that.setDetail.address,
                link:'http://user.4008005216.com/main/ddetail?id='+id,
                imgUrl: that.baseUrl+that.setDetail.images, 
                type: '',
                dataUrl: '', 
                success: function () {
                }
            });
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.getDetail();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .crowdDetailApp{
    background:#ececec;
    width:100%
  }
  .crowdDetailApp .swiper-slide{
    width:100%
  }
  .crowdDetailApp .swiper-slide img{
    display:block;
    width:100%;
  }
  .crowdDetailApp .cont{
    width:100%;
    display:block;
    margin:0 auto;
    z-index:99;
  }
  .crowdDetailApp .info{
    width:100%;
    display:block;
    position:relative;
    background:#fff;
  }
  .crowdDetailApp .info .goDetail{
    position:absolute;
    right:3%;
    transform: translateY(-50%);
    top:20%;
    font-size:14px;
    color:#666
  }
  .crowdDetailApp .info h2{
    font-size:15px;
    padding-top:10px;
    width:92%;
    display:block;
    margin:0 auto;
    font-weight:normal;
    color:#333;
  }
  .crowdDetailApp .info h2.box{
    border-top:solid 1px #f5f5f5;
    padding:15px 0
  }
  .crowdDetailApp .info h2 p{
    padding-bottom:5px;
    line-height:22px
  }
  .crowdDetailApp .info h2.title{
    color:#000;
    font-weight:bold;
    font-size:16px;
    padding:15px 0 12px 0
  }
  .crowdDetailApp .info h2.title div{
    margin-bottom:8px
  }
  .crowdDetailApp .info h2.title span{
    font-weight:normal;
    display:inlie-block;
    border:solid 1px #F56C6C;
    font-size:12px;
    padding:3px 5px;
    border-radius: 4px;
    color:#F56C6C;
    margin-right:8px;
  }
  .crowdDetailApp .info h2.title span.curt{
    color:#67C23A;
    border-color:#67C23A
  }
  .crowdDetailApp .info h2 a{
    color:#999;
    text-decoration: none;
    float:right
  }

  .crowdDetailApp .trends{
    background:#fff;
    width:100%;
    margin-top:10px;
    padding-bottom:15px
  }
  .crowdDetailApp .trends h2{
    font-size:16px;
    width:92%;
    margin:0 auto;
    padding:15px 0
  }


  .crowdDetailApp .trends dl{
    width:92%;
    display:block;
    margin:0 auto;
  }
  .crowdDetailApp .trends dl dd:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .crowdDetailApp .trends dl dd .avatar{
    float:left;
    width:35px;
    border-radius: 50%;
  }
  .crowdDetailApp .trends dl dd{
    margin-bottom:15px;
  }
  .crowdDetailApp .trends dl dd .plnr{
    float:left;
    width:88%;
    margin-left:2%;
    padding-bottom:15px;
    border-bottom:1px solid #EBEBEB;
  }
  .crowdDetailApp .trends dl dd .plnr .h2 span{
    font-size:15px;
    color:#000;
    font-weight:bold
  }
  .crowdDetailApp .trends dl dd .plnr .h2 font{
    float:right;
    font-weight:normal;
    font-size:15px;
    color:#999;
  }
  .crowdDetailApp .trends dl dd .plnr p{
    font-size:14px;
    color:#666;
    padding-top:5px;
    letter-spacing: 1px;
    text-align: justify;
    padding-bottom:5px;
  }
  .crowdDetailApp .trends dl dd:last-child .plnr{
    border-bottom:none;
  }
  .crowdDetailApp .trends .video-js .vjs-big-play-button {
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    outline: none!importrant;
  }
  .crowdDetailApp .trends dl dd .images{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .crowdDetailApp .trends dl dd .images img{
    width:31.5%;
    border:0;
    border-radius:5px;
    margin-bottom:8px
  }
  .crowdDetailApp .footer1{
    height: 50px;
    background: #fff;
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0;
    z-index: 999
  }
  .crowdDetailApp .footer1 .foot-title{
    float: left;
    margin-left: 4%;
    height:50px;
    line-height:50px;
  }
  .crowdDetailApp .footer1 .foot-title span{
    font-size: 14px;
    color: #727272;
  }
  .crowdDetailApp .footer1 .foot-title span:first-child{
    margin-right:8px
  }
  .crowdDetailApp .footer1 .foot-title span b{
    color: #f00;
    font-size:17px;
    font-weight:500;
  }

  .crowdDetailApp .footer1 .foot-title span i{
    color: #f00;
    font-size:12px;
    font-style:normal
  }

  .crowdDetailApp .footer1 .pay{
    float: right;
    color: #fff;
    margin-right: 4%;
    margin-top:5px;
    width:40%
  }
  .crowdDetailApp .footer1 .pay span{
    float:left;
    height:40px;
    line-height:40px;
    font-size: 14px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background: #f00;
    border-radius:40px;
  }


  .chickenList li{
    width:92%;
    border-bottom:solid 1px #ebebeb;
    margin:0 auto;
    background:#fff;
    padding:10px 0
  }
  .chickenList li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .chickenList li .title{
    font-size:16px;
  }
  .chickenList li .title i{
    font-size:12px;
    color:#f00;
    font-style: normal;
  }
  .chickenList li .title font{
    float:right;
    font-size:14px;
    color:#666
  }
  .chickenList li .address{
    color:#666;
    font-size:14px;
    padding-top:5px;
    display:block;
  }
</style>